import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IInspectionType } from '../interfaces/inspection-type';
import { IInspectionTypeFilter } from '../interfaces/inspection-type-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class InspectionTypeService extends EditService<IInspectionType, IInspectionTypeFilter> {
  url = '/api/inspectiontypes';
  entityTitle = 'InspectionType';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
